import { defineInterface } from '@nzyme/ioc/Interface.js';
import { ENV } from './environments.js';
/**
 * Config document of the current runtime.
 *
 * Every runtime installs its own document in its setup function — from the packaged file
 * ({@link readRuntimeConfigFile}), from the environment ({@link createEnvRuntimeConfig}), or as a
 * literal. There is deliberately no default: a runtime that resolves a config key without
 * installing a document fails naming this interface, instead of reaching for a file that a browser
 * bundle cannot read and a process running from an unexpected directory would not find.
 */
export const RuntimeConfig = defineInterface({ name: 'RuntimeConfig' });
/** Name of the document a deployed runtime is packaged with. */
export const RUNTIME_CONFIG_FILE = `.config.${ENV}.json`;
/**
 * Env variable carrying an inline config document, for handing a resolved config to a child process
 * that has no document on disk — the `drizzle-kit` subprocess must target the database its parent
 * resolved, and during a deploy those credentials come straight from Pulumi outputs and are never
 * written to a file.
 */
export const RUNTIME_CONFIG_VARIABLE = 'RUNTIME_CONFIG';
/** Parses a runtime config document. */
export function parseRuntimeConfig(json) {
    return JSON.parse(json);
}
//# sourceMappingURL=RuntimeConfig.js.map